// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../myImages/Golden Hour Coastal Cliffs.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
    --sq-gold: #e3bd3e;
    --sq-gold-light: #f0d06a;
    --sq-gold-dark: #b8941e;
    --sq-dark: #0f1a18;
    --sq-dark2: #1a2b28;
    --sq-dark3: #243d39;
    --sq-text-muted: #8a9e9b;
    --sq-white: #ffffff;
    --sq-off-white: #f8f6f0;
    --sq-border: #e8e2d5;
}

* {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
}

body.sq-body {
    font-family: 'DM Sans', sans-serif;
    min-height: 100vh;
    background: var(--sq-off-white);
    display: flex;
    align-items: stretch;
}

/* ── Layout ─────────────────────────────────── */
.sq-wrapper {
    display: flex;
    width: 100%;
    min-height: 100vh;
}

/* ── LEFT PANEL ──────────────────────────────── */
.sq-left {
    flex: 0 0 48%;
    max-width: 48%;
    background: var(--sq-white);
    display: flex;
    flex-direction: column;
    padding: 2.5rem 3.5rem;
    position: relative;
    overflow: hidden;
    align-items: center;
}

.sq-left::before {
    content: '';
    position: absolute;
    top: -80px;
    right: -80px;
    width: 260px;
    height: 260px;
    border-radius: 50%;
    background: radial-gradient(circle, rgba(227, 189, 62, 0.12) 0%, transparent 70%);
    pointer-events: none;
}

.logo-img {
    max-width: 200px;
}

.sq-logo {
    display: flex;
    align-items: center;
    gap: 0.55rem;
    margin-bottom: 3.5rem;
    text-decoration: none;
}

.sq-logo-icon {
    width: 38px;
    height: 38px;
    background: var(--sq-dark);
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.sq-logo-icon svg {
    color: var(--sq-gold);
}

.sq-logo-text {
    font-family: 'DM Sans', sans-serif;
    font-weight: 600;
    font-size: 1.25rem;
    color: var(--sq-dark);
}

.sq-form-section {
    flex: 1 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    max-width: 400px;
    width: 400px;
}

.sq-heading {
    /* font-family: 'Playfair Display', serif; */
    font-family: 'Gilroy-Bold', serif;
    font-size: 2rem;
    font-weight: 700;
    color: var(--sq-dark);
    margin-bottom: 0.6rem;
    line-height: 1.2;
}

.sq-subheading {
    color: var(--sq-text-muted);
    font-size: 0.92rem;
    margin-bottom: 2.2rem;
    line-height: 1.6;
}

.sq-label {
    font-size: 0.82rem;
    font-weight: 500;
    color: #4a5a57;
    margin-bottom: 0.4rem;
    display: block;
}

.sq-input-wrap {
    position: relative;
    margin-bottom: 1.25rem;
}

.sq-input-icon {
    position: absolute;
    left: 14px;
    top: 50%;
    transform: translateY(-50%);
    color: var(--sq-text-muted);
    pointer-events: none;
}

.sq-input {
    width: 100%;
    padding: 0.75rem 1rem 0.75rem 2.75rem;
    border: 1.5px solid var(--sq-border);
    border-radius: 10px;
    font-family: 'DM Sans', sans-serif;
    font-size: 0.92rem;
    color: var(--sq-dark);
    background: var(--sq-off-white);
    transition: border-color 0.2s, box-shadow 0.2s;
    outline: none;
}

.sq-input:focus {
    border-color: var(--sq-gold);
    box-shadow: 0 0 0 3px rgba(227, 189, 62, 0.18);
    background: var(--sq-white);
}

.sq-input.no-icon {
    padding: 0.75rem 1rem 0.75rem 0.75rem;
}

.sq-pw-toggle {
    position: absolute;
    right: 14px;
    top: 50%;
    transform: translateY(-50%);
    background: none;
    border: none;
    color: var(--sq-text-muted);
    cursor: pointer;
    padding: 0;
    display: flex;
    align-items: center;
}

.sq-forgot {
    text-align: right;
    margin-top: -0.75rem;
    margin-bottom: 1.5rem;
}

.sq-forgot a {
    font-size: 0.82rem;
    color: var(--sq-gold-dark);
    text-decoration: none;
    font-weight: 500;
}

.sq-forgot a:hover {
    text-decoration: underline;
}

.login-err { 
    bottom: -20px;
}

.sq-btn-primary {
    width: 100%;
    padding: 0.82rem;
    background: var(--gold-color);
    color: var(--sq-dark);
    font-family: 'DM Sans', sans-serif;
    font-weight: 600;
    font-size: 0.95rem;
    border: none;
    border-radius: 10px;
    cursor: pointer;
    letter-spacing: 0.02em;
    transition: transform 0.15s, box-shadow 0.15s;
    box-shadow: 0 4px 16px rgba(227, 189, 62, 0.35);
}

.sq-btn-primary:hover {
    transform: translateY(-1px);
    box-shadow: 0 6px 22px rgba(227, 189, 62, 0.45);
}

.sq-divider {
    display: flex;
    align-items: center;
    gap: 1rem;
    margin: 1.4rem 0;
    color: var(--sq-text-muted);
    font-size: 0.82rem;
}

.sq-divider::before,
.sq-divider::after {
    content: '';
    flex: 1 1;
    height: 1px;
    background: var(--sq-border);
}

.sq-btn-social {
    width: 100%;
    padding: 0.72rem;
    background: var(--sq-white);
    border: 1.5px solid var(--sq-border);
    border-radius: 10px;
    font-family: 'DM Sans', sans-serif;
    font-size: 0.9rem;
    color: var(--sq-dark);
    font-weight: 500;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.6rem;
    transition: border-color 0.2s, background 0.2s;
    margin-bottom: 0.75rem;
}

.sq-btn-social:hover {
    border-color: var(--sq-gold);
    background: rgba(227, 189, 62, 0.05);
}

.sq-signup-link {
    text-align: center;
    /* margin-top: 1.5rem; */
    font-size: 0.88rem;
    color: var(--sq-text-muted);
}

.sq-signup-link a {
    color: var(--sq-gold-dark);
    font-weight: 600;
    text-decoration: none;
}

.sq-signup-link a:hover {
    text-decoration: underline;
}

/* ── RIGHT PANEL ─────────────────────────────── */
.sq-right {
    flex: 1 1;
    background:
        linear-gradient(180deg, rgba(23, 18, 2, 0.25) 0%, rgba(23, 18, 2, 0.8) 100%),
        url(${___CSS_LOADER_URL_REPLACEMENT_0___}) center / cover no-repeat,
        #171202;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 3.5rem 3.5rem 3rem;
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    width: 52%;
    overflow: hidden;
}

/* subtle radial glow top-right */
.sq-right::before {
    content: '';
    position: absolute;
    top: -100px;
    right: -100px;
    width: 420px;
    height: 420px;
    border-radius: 50%;
    background: radial-gradient(circle, rgba(227, 189, 62, 0.08) 0%, transparent 65%);
    pointer-events: none;
}

/* subtle radial glow bottom-left */
.sq-right::after {
    content: '';
    position: absolute;
    bottom: -80px;
    left: -80px;
    width: 380px;
    height: 380px;
    border-radius: 50%;
    background: radial-gradient(circle, rgba(227, 189, 62, 0.06) 0%, transparent 65%);
    pointer-events: none;
}

.sq-right-content {
    position: relative;
    z-index: 1;
    flex: 1 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding-bottom: 2.5rem;
}

.sq-hero-title {
    font-family: 'Manrope-Bold', serif;
    font-size: 3rem;
    font-weight: 700;
    color: var(--sq-white);
    line-height: 1.15;
    margin-bottom: 2.5rem;
    letter-spacing: -0.01em;
}

/* quote block — open style, no card box */
.sq-quote-block {
    position: relative;
    padding-left: 0;
}

.sq-big-quote {
    font-family: Georgia, 'Times New Roman', serif;
    font-size: 5rem;
    line-height: 0.7;
    color: var(--sq-gold);
    display: block;
    margin-bottom: 0.75rem;
    opacity: 0.9;
}

.sq-quote-text {
    font-size: 0.95rem;
    color: rgba(255, 255, 255, 0.80);
    line-height: 1.75;
    margin-bottom: 1.5rem;
    /* font-style: italic; */
    font-family: 'Manrope-SemiBold', serif;
}

.sq-quote-author {
    display: flex;
    align-items: center;
    gap: 0.85rem;
}

.sq-author-avatar {
    width: 44px;
    height: 44px;
    border-radius: 50%;
    background: linear-gradient(135deg, var(--sq-gold-light) 0%, var(--sq-gold-dark) 100%);
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 700;
    color: var(--sq-dark);
    font-size: 0.88rem;
    flex-shrink: 0;
    border: 2px solid rgba(227, 189, 62, 0.4);
}

.sq-author-name {
    font-size: 0.9rem;
    font-weight: 600;
    color: var(--sq-white);
}

.sq-author-role {
    font-size: 0.78rem;
    color: rgba(255, 255, 255, 0.45);
    margin-top: 0.1rem;
}

/* Logos section */
.sq-logos-section {
    position: relative;
    z-index: 1;
}

.sq-logos-divider {
    width: 100%;
    height: 1px;
    background: rgba(255, 255, 255, 0.12);
    margin-bottom: 1.25rem;
}

.sq-logos-label {
    font-size: 0.7rem;
    letter-spacing: 0.15em;
    text-transform: uppercase;
    /* color: rgba(255, 255, 255, 0.35); */
    color: white;
    margin-bottom: 1.1rem;
}

.sq-logos-row {
    display: flex;
    gap: 1.8rem;
    align-items: center;
    flex-wrap: wrap;
    margin-bottom: 0.65rem;
}

.sq-brand-name {
    font-size: 0.82rem;
    font-weight: 600;
    color: rgba(255, 255, 255, 0.50);
    letter-spacing: 0.04em;
    display: flex;
    align-items: center;
    gap: 0.35rem;
    transition: color 0.2s;
    cursor: default;
}

.sq-brand-name:hover {
    color: rgba(227, 189, 62, 0.8);
}

.sq-brand-dot {
    width: 5px;
    height: 5px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.2);
    flex-shrink: 0;
}

/* ── RESPONSIVE ──────────────────────────────── */
@media (max-width: 960px) {
    .sq-left {
        flex: 0 0 52%;
        max-width: 52%;
        padding: 2rem 2.2rem;
    }

    .sq-right {
        padding: 2.5rem 2rem;
    }

    .sq-hero-title {
        font-size: 2.3rem;
    }
}

@media (max-width: 700px) {
    .sq-wrapper {
        flex-direction: column;
    }

    .sq-left {
        flex: none;
        max-width: 100%;
        padding: 2rem 1.5rem;
    }

    .sq-right {
        width: 100%;
        position: relative;
        padding: 2.5rem 1.5rem;
        min-height: auto;
    }

    .sq-form-section {
        max-width: 100%;
    }

    .sq-hero-title {
        font-size: 1.85rem;
    }

    .sq-logos-row {
        gap: 1.2rem;
    }
}

/* animations */
@keyframes sq-fade-up {
    from {
        opacity: 0;
        transform: translateY(18px);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
}

.sq-form-section {
    animation: sq-fade-up 0.55s ease both;
}

.sq-right-content {
    animation: sq-fade-up 0.55s 0.15s ease both;
}

.sq-logos-section {
    animation: sq-fade-up 0.55s 0.3s ease both;
}

.iti__tel-input {
    width: 100%;
    padding: 0.75rem 1rem 0.75rem 2.75rem;
    border: 1.5px solid var(--sq-border);
    border-radius: 10px;
    font-family: 'DM Sans', sans-serif;
    font-size: 0.92rem;
    color: var(--sq-dark);
    background: var(--sq-off-white);
    transition: border-color 0.2s, box-shadow 0.2s;
    outline: none;
}

.iti__tel-input:focus {
    border-color: var(--sq-gold);
    box-shadow: 0 0 0 3px rgba(227, 189, 62, 0.18);
    background: var(--sq-white);
}

.iti__country-container {
    border: 1.5px solid var(--sq-border);
    border-radius: 10px;
    font-family: 'DM Sans', sans-serif;
    font-size: 0.92rem;
    color: var(--sq-dark);
    background: var(--sq-off-white);
    transition: border-color 0.2s, box-shadow 0.2s;
    outline: none;
}

.select2-selection.select2-selection--single {
    font-size: 0.92rem;
    color: var(--sq-dark);
    background: var(--sq-off-white);
}

button:disabled{
    opacity: 0.766645;
}

.sq-btn-primary i {
    margin-left: 5px;
    font-size: 11px;
}

.provider_list {
    display: flex;
    flex-wrap: wrap;
    /* grid-template-columns: 1fr 1fr 1fr 1fr; */
    gap: 20px;
    text-align: center;
    padding-top: 20px;
}

.provider_list .box_box svg {
    width: 60px;
    height: 60px;
    color: #515760;
    transition: 0.3s all;
}

.provider_list .box_box img {
    width: 90px;
}

.provider_list .box_box a:hover svg {
    color: var(--gold-color);
}

.provider_list .box_box h6 {
    color: #23262F;
    font-family: 'Manrope-Bold';
}`, "",{"version":3,"sources":["webpack://./src/assest/css/login.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,wBAAwB;IACxB,uBAAuB;IACvB,kBAAkB;IAClB,mBAAmB;IACnB,mBAAmB;IACnB,wBAAwB;IACxB,mBAAmB;IACnB,uBAAuB;IACvB,oBAAoB;AACxB;;AAEA;IACI,sBAAsB;IACtB,SAAS;IACT,UAAU;AACd;;AAEA;IACI,kCAAkC;IAClC,iBAAiB;IACjB,+BAA+B;IAC/B,aAAa;IACb,oBAAoB;AACxB;;AAEA,kDAAkD;AAClD;IACI,aAAa;IACb,WAAW;IACX,iBAAiB;AACrB;;AAEA,mDAAmD;AACnD;IACI,aAAa;IACb,cAAc;IACd,2BAA2B;IAC3B,aAAa;IACb,sBAAsB;IACtB,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,iFAAiF;IACjF,oBAAoB;AACxB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,qBAAqB;IACrB,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,0BAA0B;IAC1B,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,kCAAkC;IAClC,gBAAgB;IAChB,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,SAAO;IACP,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,4CAA4C;IAC5C,iCAAiC;IACjC,eAAe;IACf,gBAAgB;IAChB,qBAAqB;IACrB,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;IAC3B,kBAAkB;IAClB,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,2BAA2B;IAC3B,2BAA2B;IAC3B,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,qCAAqC;IACrC,oCAAoC;IACpC,mBAAmB;IACnB,kCAAkC;IAClC,kBAAkB;IAClB,qBAAqB;IACrB,+BAA+B;IAC/B,8CAA8C;IAC9C,aAAa;AACjB;;AAEA;IACI,4BAA4B;IAC5B,8CAA8C;IAC9C,2BAA2B;AAC/B;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,2BAA2B;IAC3B,gBAAgB;IAChB,YAAY;IACZ,2BAA2B;IAC3B,eAAe;IACf,UAAU;IACV,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,oBAAoB;IACpB,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,0BAA0B;IAC1B,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,6BAA6B;IAC7B,qBAAqB;IACrB,kCAAkC;IAClC,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;IACZ,mBAAmB;IACnB,eAAe;IACf,sBAAsB;IACtB,6CAA6C;IAC7C,+CAA+C;AACnD;;AAEA;IACI,2BAA2B;IAC3B,+CAA+C;AACnD;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,gBAAgB;IAChB,2BAA2B;IAC3B,kBAAkB;AACtB;;AAEA;;IAEI,WAAW;IACX,SAAO;IACP,WAAW;IACX,4BAA4B;AAChC;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,2BAA2B;IAC3B,oCAAoC;IACpC,mBAAmB;IACnB,kCAAkC;IAClC,iBAAiB;IACjB,qBAAqB;IACrB,gBAAgB;IAChB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,8CAA8C;IAC9C,sBAAsB;AAC1B;;AAEA;IACI,4BAA4B;IAC5B,oCAAoC;AACxC;;AAEA;IACI,kBAAkB;IAClB,wBAAwB;IACxB,kBAAkB;IAClB,2BAA2B;AAC/B;;AAEA;IACI,0BAA0B;IAC1B,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA,mDAAmD;AACnD;IACI,SAAO;IACP;;;eAGW;IACX,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,2BAA2B;IAC3B,eAAe;IACf,MAAM;IACN,QAAQ;IACR,SAAS;IACT,UAAU;IACV,gBAAgB;AACpB;;AAEA,iCAAiC;AACjC;IACI,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,iFAAiF;IACjF,oBAAoB;AACxB;;AAEA,mCAAmC;AACnC;IACI,WAAW;IACX,kBAAkB;IAClB,aAAa;IACb,WAAW;IACX,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,iFAAiF;IACjF,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,SAAO;IACP,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,sBAAsB;AAC1B;;AAEA;IACI,kCAAkC;IAClC,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,iBAAiB;IACjB,qBAAqB;IACrB,uBAAuB;AAC3B;;AAEA,0CAA0C;AAC1C;IACI,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,8CAA8C;IAC9C,eAAe;IACf,gBAAgB;IAChB,qBAAqB;IACrB,cAAc;IACd,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,gCAAgC;IAChC,iBAAiB;IACjB,qBAAqB;IACrB,wBAAwB;IACxB,sCAAsC;AAC1C;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,sFAAsF;IACtF,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,qBAAqB;IACrB,kBAAkB;IAClB,cAAc;IACd,yCAAyC;AAC7C;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,gCAAgC;IAChC,kBAAkB;AACtB;;AAEA,kBAAkB;AAClB;IACI,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,WAAW;IACX,WAAW;IACX,qCAAqC;IACrC,sBAAsB;AAC1B;;AAEA;IACI,iBAAiB;IACjB,sBAAsB;IACtB,yBAAyB;IACzB,sCAAsC;IACtC,YAAY;IACZ,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,WAAW;IACX,mBAAmB;IACnB,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,gCAAgC;IAChC,sBAAsB;IACtB,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,sBAAsB;IACtB,eAAe;AACnB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,oCAAoC;IACpC,cAAc;AAClB;;AAEA,mDAAmD;AACnD;IACI;QACI,aAAa;QACb,cAAc;QACd,oBAAoB;IACxB;;IAEA;QACI,oBAAoB;IACxB;;IAEA;QACI,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,sBAAsB;IAC1B;;IAEA;QACI,UAAU;QACV,eAAe;QACf,oBAAoB;IACxB;;IAEA;QACI,WAAW;QACX,kBAAkB;QAClB,sBAAsB;QACtB,gBAAgB;IACpB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,WAAW;IACf;AACJ;;AAEA,eAAe;AACf;IACI;QACI,UAAU;QACV,2BAA2B;IAC/B;;IAEA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,2CAA2C;AAC/C;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,WAAW;IACX,qCAAqC;IACrC,oCAAoC;IACpC,mBAAmB;IACnB,kCAAkC;IAClC,kBAAkB;IAClB,qBAAqB;IACrB,+BAA+B;IAC/B,8CAA8C;IAC9C,aAAa;AACjB;;AAEA;IACI,4BAA4B;IAC5B,8CAA8C;IAC9C,2BAA2B;AAC/B;;AAEA;IACI,oCAAoC;IACpC,mBAAmB;IACnB,kCAAkC;IAClC,kBAAkB;IAClB,qBAAqB;IACrB,+BAA+B;IAC/B,8CAA8C;IAC9C,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,+BAA+B;AACnC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,4CAA4C;IAC5C,SAAS;IACT,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;IACd,oBAAoB;AACxB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,cAAc;IACd,2BAA2B;AAC/B","sourcesContent":[":root {\n    --sq-gold: #e3bd3e;\n    --sq-gold-light: #f0d06a;\n    --sq-gold-dark: #b8941e;\n    --sq-dark: #0f1a18;\n    --sq-dark2: #1a2b28;\n    --sq-dark3: #243d39;\n    --sq-text-muted: #8a9e9b;\n    --sq-white: #ffffff;\n    --sq-off-white: #f8f6f0;\n    --sq-border: #e8e2d5;\n}\n\n* {\n    box-sizing: border-box;\n    margin: 0;\n    padding: 0;\n}\n\nbody.sq-body {\n    font-family: 'DM Sans', sans-serif;\n    min-height: 100vh;\n    background: var(--sq-off-white);\n    display: flex;\n    align-items: stretch;\n}\n\n/* ── Layout ─────────────────────────────────── */\n.sq-wrapper {\n    display: flex;\n    width: 100%;\n    min-height: 100vh;\n}\n\n/* ── LEFT PANEL ──────────────────────────────── */\n.sq-left {\n    flex: 0 0 48%;\n    max-width: 48%;\n    background: var(--sq-white);\n    display: flex;\n    flex-direction: column;\n    padding: 2.5rem 3.5rem;\n    position: relative;\n    overflow: hidden;\n    align-items: center;\n}\n\n.sq-left::before {\n    content: '';\n    position: absolute;\n    top: -80px;\n    right: -80px;\n    width: 260px;\n    height: 260px;\n    border-radius: 50%;\n    background: radial-gradient(circle, rgba(227, 189, 62, 0.12) 0%, transparent 70%);\n    pointer-events: none;\n}\n\n.logo-img {\n    max-width: 200px;\n}\n\n.sq-logo {\n    display: flex;\n    align-items: center;\n    gap: 0.55rem;\n    margin-bottom: 3.5rem;\n    text-decoration: none;\n}\n\n.sq-logo-icon {\n    width: 38px;\n    height: 38px;\n    background: var(--sq-dark);\n    border-radius: 10px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.sq-logo-icon svg {\n    color: var(--sq-gold);\n}\n\n.sq-logo-text {\n    font-family: 'DM Sans', sans-serif;\n    font-weight: 600;\n    font-size: 1.25rem;\n    color: var(--sq-dark);\n}\n\n.sq-form-section {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    max-width: 400px;\n    width: 400px;\n}\n\n.sq-heading {\n    /* font-family: 'Playfair Display', serif; */\n    font-family: 'Gilroy-Bold', serif;\n    font-size: 2rem;\n    font-weight: 700;\n    color: var(--sq-dark);\n    margin-bottom: 0.6rem;\n    line-height: 1.2;\n}\n\n.sq-subheading {\n    color: var(--sq-text-muted);\n    font-size: 0.92rem;\n    margin-bottom: 2.2rem;\n    line-height: 1.6;\n}\n\n.sq-label {\n    font-size: 0.82rem;\n    font-weight: 500;\n    color: #4a5a57;\n    margin-bottom: 0.4rem;\n    display: block;\n}\n\n.sq-input-wrap {\n    position: relative;\n    margin-bottom: 1.25rem;\n}\n\n.sq-input-icon {\n    position: absolute;\n    left: 14px;\n    top: 50%;\n    transform: translateY(-50%);\n    color: var(--sq-text-muted);\n    pointer-events: none;\n}\n\n.sq-input {\n    width: 100%;\n    padding: 0.75rem 1rem 0.75rem 2.75rem;\n    border: 1.5px solid var(--sq-border);\n    border-radius: 10px;\n    font-family: 'DM Sans', sans-serif;\n    font-size: 0.92rem;\n    color: var(--sq-dark);\n    background: var(--sq-off-white);\n    transition: border-color 0.2s, box-shadow 0.2s;\n    outline: none;\n}\n\n.sq-input:focus {\n    border-color: var(--sq-gold);\n    box-shadow: 0 0 0 3px rgba(227, 189, 62, 0.18);\n    background: var(--sq-white);\n}\n\n.sq-input.no-icon {\n    padding: 0.75rem 1rem 0.75rem 0.75rem;\n}\n\n.sq-pw-toggle {\n    position: absolute;\n    right: 14px;\n    top: 50%;\n    transform: translateY(-50%);\n    background: none;\n    border: none;\n    color: var(--sq-text-muted);\n    cursor: pointer;\n    padding: 0;\n    display: flex;\n    align-items: center;\n}\n\n.sq-forgot {\n    text-align: right;\n    margin-top: -0.75rem;\n    margin-bottom: 1.5rem;\n}\n\n.sq-forgot a {\n    font-size: 0.82rem;\n    color: var(--sq-gold-dark);\n    text-decoration: none;\n    font-weight: 500;\n}\n\n.sq-forgot a:hover {\n    text-decoration: underline;\n}\n\n.login-err { \n    bottom: -20px;\n}\n\n.sq-btn-primary {\n    width: 100%;\n    padding: 0.82rem;\n    background: var(--gold-color);\n    color: var(--sq-dark);\n    font-family: 'DM Sans', sans-serif;\n    font-weight: 600;\n    font-size: 0.95rem;\n    border: none;\n    border-radius: 10px;\n    cursor: pointer;\n    letter-spacing: 0.02em;\n    transition: transform 0.15s, box-shadow 0.15s;\n    box-shadow: 0 4px 16px rgba(227, 189, 62, 0.35);\n}\n\n.sq-btn-primary:hover {\n    transform: translateY(-1px);\n    box-shadow: 0 6px 22px rgba(227, 189, 62, 0.45);\n}\n\n.sq-divider {\n    display: flex;\n    align-items: center;\n    gap: 1rem;\n    margin: 1.4rem 0;\n    color: var(--sq-text-muted);\n    font-size: 0.82rem;\n}\n\n.sq-divider::before,\n.sq-divider::after {\n    content: '';\n    flex: 1;\n    height: 1px;\n    background: var(--sq-border);\n}\n\n.sq-btn-social {\n    width: 100%;\n    padding: 0.72rem;\n    background: var(--sq-white);\n    border: 1.5px solid var(--sq-border);\n    border-radius: 10px;\n    font-family: 'DM Sans', sans-serif;\n    font-size: 0.9rem;\n    color: var(--sq-dark);\n    font-weight: 500;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 0.6rem;\n    transition: border-color 0.2s, background 0.2s;\n    margin-bottom: 0.75rem;\n}\n\n.sq-btn-social:hover {\n    border-color: var(--sq-gold);\n    background: rgba(227, 189, 62, 0.05);\n}\n\n.sq-signup-link {\n    text-align: center;\n    /* margin-top: 1.5rem; */\n    font-size: 0.88rem;\n    color: var(--sq-text-muted);\n}\n\n.sq-signup-link a {\n    color: var(--sq-gold-dark);\n    font-weight: 600;\n    text-decoration: none;\n}\n\n.sq-signup-link a:hover {\n    text-decoration: underline;\n}\n\n/* ── RIGHT PANEL ─────────────────────────────── */\n.sq-right {\n    flex: 1;\n    background:\n        linear-gradient(180deg, rgba(23, 18, 2, 0.25) 0%, rgba(23, 18, 2, 0.8) 100%),\n        url(\"../myImages/Golden Hour Coastal Cliffs.png\") center / cover no-repeat,\n        #171202;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    padding: 3.5rem 3.5rem 3rem;\n    position: fixed;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    width: 52%;\n    overflow: hidden;\n}\n\n/* subtle radial glow top-right */\n.sq-right::before {\n    content: '';\n    position: absolute;\n    top: -100px;\n    right: -100px;\n    width: 420px;\n    height: 420px;\n    border-radius: 50%;\n    background: radial-gradient(circle, rgba(227, 189, 62, 0.08) 0%, transparent 65%);\n    pointer-events: none;\n}\n\n/* subtle radial glow bottom-left */\n.sq-right::after {\n    content: '';\n    position: absolute;\n    bottom: -80px;\n    left: -80px;\n    width: 380px;\n    height: 380px;\n    border-radius: 50%;\n    background: radial-gradient(circle, rgba(227, 189, 62, 0.06) 0%, transparent 65%);\n    pointer-events: none;\n}\n\n.sq-right-content {\n    position: relative;\n    z-index: 1;\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    padding-bottom: 2.5rem;\n}\n\n.sq-hero-title {\n    font-family: 'Manrope-Bold', serif;\n    font-size: 3rem;\n    font-weight: 700;\n    color: var(--sq-white);\n    line-height: 1.15;\n    margin-bottom: 2.5rem;\n    letter-spacing: -0.01em;\n}\n\n/* quote block — open style, no card box */\n.sq-quote-block {\n    position: relative;\n    padding-left: 0;\n}\n\n.sq-big-quote {\n    font-family: Georgia, 'Times New Roman', serif;\n    font-size: 5rem;\n    line-height: 0.7;\n    color: var(--sq-gold);\n    display: block;\n    margin-bottom: 0.75rem;\n    opacity: 0.9;\n}\n\n.sq-quote-text {\n    font-size: 0.95rem;\n    color: rgba(255, 255, 255, 0.80);\n    line-height: 1.75;\n    margin-bottom: 1.5rem;\n    /* font-style: italic; */\n    font-family: 'Manrope-SemiBold', serif;\n}\n\n.sq-quote-author {\n    display: flex;\n    align-items: center;\n    gap: 0.85rem;\n}\n\n.sq-author-avatar {\n    width: 44px;\n    height: 44px;\n    border-radius: 50%;\n    background: linear-gradient(135deg, var(--sq-gold-light) 0%, var(--sq-gold-dark) 100%);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-weight: 700;\n    color: var(--sq-dark);\n    font-size: 0.88rem;\n    flex-shrink: 0;\n    border: 2px solid rgba(227, 189, 62, 0.4);\n}\n\n.sq-author-name {\n    font-size: 0.9rem;\n    font-weight: 600;\n    color: var(--sq-white);\n}\n\n.sq-author-role {\n    font-size: 0.78rem;\n    color: rgba(255, 255, 255, 0.45);\n    margin-top: 0.1rem;\n}\n\n/* Logos section */\n.sq-logos-section {\n    position: relative;\n    z-index: 1;\n}\n\n.sq-logos-divider {\n    width: 100%;\n    height: 1px;\n    background: rgba(255, 255, 255, 0.12);\n    margin-bottom: 1.25rem;\n}\n\n.sq-logos-label {\n    font-size: 0.7rem;\n    letter-spacing: 0.15em;\n    text-transform: uppercase;\n    /* color: rgba(255, 255, 255, 0.35); */\n    color: white;\n    margin-bottom: 1.1rem;\n}\n\n.sq-logos-row {\n    display: flex;\n    gap: 1.8rem;\n    align-items: center;\n    flex-wrap: wrap;\n    margin-bottom: 0.65rem;\n}\n\n.sq-brand-name {\n    font-size: 0.82rem;\n    font-weight: 600;\n    color: rgba(255, 255, 255, 0.50);\n    letter-spacing: 0.04em;\n    display: flex;\n    align-items: center;\n    gap: 0.35rem;\n    transition: color 0.2s;\n    cursor: default;\n}\n\n.sq-brand-name:hover {\n    color: rgba(227, 189, 62, 0.8);\n}\n\n.sq-brand-dot {\n    width: 5px;\n    height: 5px;\n    border-radius: 50%;\n    background: rgba(255, 255, 255, 0.2);\n    flex-shrink: 0;\n}\n\n/* ── RESPONSIVE ──────────────────────────────── */\n@media (max-width: 960px) {\n    .sq-left {\n        flex: 0 0 52%;\n        max-width: 52%;\n        padding: 2rem 2.2rem;\n    }\n\n    .sq-right {\n        padding: 2.5rem 2rem;\n    }\n\n    .sq-hero-title {\n        font-size: 2.3rem;\n    }\n}\n\n@media (max-width: 700px) {\n    .sq-wrapper {\n        flex-direction: column;\n    }\n\n    .sq-left {\n        flex: none;\n        max-width: 100%;\n        padding: 2rem 1.5rem;\n    }\n\n    .sq-right {\n        width: 100%;\n        position: relative;\n        padding: 2.5rem 1.5rem;\n        min-height: auto;\n    }\n\n    .sq-form-section {\n        max-width: 100%;\n    }\n\n    .sq-hero-title {\n        font-size: 1.85rem;\n    }\n\n    .sq-logos-row {\n        gap: 1.2rem;\n    }\n}\n\n/* animations */\n@keyframes sq-fade-up {\n    from {\n        opacity: 0;\n        transform: translateY(18px);\n    }\n\n    to {\n        opacity: 1;\n        transform: translateY(0);\n    }\n}\n\n.sq-form-section {\n    animation: sq-fade-up 0.55s ease both;\n}\n\n.sq-right-content {\n    animation: sq-fade-up 0.55s 0.15s ease both;\n}\n\n.sq-logos-section {\n    animation: sq-fade-up 0.55s 0.3s ease both;\n}\n\n.iti__tel-input {\n    width: 100%;\n    padding: 0.75rem 1rem 0.75rem 2.75rem;\n    border: 1.5px solid var(--sq-border);\n    border-radius: 10px;\n    font-family: 'DM Sans', sans-serif;\n    font-size: 0.92rem;\n    color: var(--sq-dark);\n    background: var(--sq-off-white);\n    transition: border-color 0.2s, box-shadow 0.2s;\n    outline: none;\n}\n\n.iti__tel-input:focus {\n    border-color: var(--sq-gold);\n    box-shadow: 0 0 0 3px rgba(227, 189, 62, 0.18);\n    background: var(--sq-white);\n}\n\n.iti__country-container {\n    border: 1.5px solid var(--sq-border);\n    border-radius: 10px;\n    font-family: 'DM Sans', sans-serif;\n    font-size: 0.92rem;\n    color: var(--sq-dark);\n    background: var(--sq-off-white);\n    transition: border-color 0.2s, box-shadow 0.2s;\n    outline: none;\n}\n\n.select2-selection.select2-selection--single {\n    font-size: 0.92rem;\n    color: var(--sq-dark);\n    background: var(--sq-off-white);\n}\n\nbutton:disabled{\n    opacity: 0.766645;\n}\n\n.sq-btn-primary i {\n    margin-left: 5px;\n    font-size: 11px;\n}\n\n.provider_list {\n    display: flex;\n    flex-wrap: wrap;\n    /* grid-template-columns: 1fr 1fr 1fr 1fr; */\n    gap: 20px;\n    text-align: center;\n    padding-top: 20px;\n}\n\n.provider_list .box_box svg {\n    width: 60px;\n    height: 60px;\n    color: #515760;\n    transition: 0.3s all;\n}\n\n.provider_list .box_box img {\n    width: 90px;\n}\n\n.provider_list .box_box a:hover svg {\n    color: var(--gold-color);\n}\n\n.provider_list .box_box h6 {\n    color: #23262F;\n    font-family: 'Manrope-Bold';\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
